import { useClerk } from '@clerk/clerk-react';
import { resetOrganizationContext } from '@src/analytics/EventTracker';
import { useUserIdentity } from '@src/stores-v2';
import { useCallback } from 'react';

function useLogOut() {
  const clerk = useClerk();
  const userIdentity = useUserIdentity();

  const logOutAsDatoUser = useCallback(() => {
    window.sessionStorage.removeItem('ctx');
    if (window.opener?.ctx) {
      window.opener.ctx = undefined;
    }
  }, []);

  const logOutAsClerkUser = useCallback(async () => {
    try {
      await clerk.signOut();
    } catch (error) {
      console.error('useLogOut: Error logging out from Clerk:', error);
    }
  }, [clerk]);

  const logOut = useCallback(async () => {
    if (userIdentity.currentUserType === 'internal') {
      // usually just a dato user, but might be logged in with Clerk as well
      console.debug('useLogOut: Logging out internal user');
      logOutAsDatoUser();
      await logOutAsClerkUser();
    } else if (userIdentity.currentUserType === 'external') {
      // Clerk user
      console.debug('useLogOut: Logging out external user');
      await logOutAsClerkUser();
    } else {
      // No user logged in, do nothing
      console.warn('useLogOut: No user is currently logged in.');
    }
    // PR4: clear analytics org context so the next session doesn't inherit it.
    resetOrganizationContext();
    // Reload the page to be taken to login flow
    window.location.reload();
  }, [userIdentity, logOutAsDatoUser, logOutAsClerkUser]);

  return { logOut };
}

export default useLogOut;
